export default __webpack_public_path__ + "slices/main/assets/public/podcast-subscribe-toggle/apple-podcasts.ca00b6aa48e94aa981d50748dfa50fcc.svg";